<template>
  <div>
    <div class="rank_row">
    <img :src="avatar">
    <h2>{{ username }}</h2>
    <div class="vertical_line_rank"></div>
    <div class="rank_points">
      <div class="rank_col">
        <p>{{ getTranslations.home_leaderboard_points }}</p>
        <label>{{ points }}</label>
      </div>
    </div>
  </div>
    <div class="rank_border"></div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'prize-user',
  inject: {
    isModal: {
      default: false,
    },
    isRank: {
      default: false,
    },
  },
  props: {
    avatar: { type: String, required: true },
    username: { type: String, required: true },
    level: { type: Number, required: true },
    points: { type: Number, required: false, default: 0 },
    rank: { type: Number, required: false, default: 0 },
  },
  computed: {
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/sharedcomponents/PrizeUser.vue